export default {
  'acc102.cashProjection': 'Projected cash balance',
  'acc102.cashTaxIncluded': 'Tax-inclusive cash balance',
  'acc102.cashTaxExcluded': 'Tax-exclusive cash balance',
  'acc102.cashReceivable': 'Projected receivables (tax-inclusive)',
  'acc102.cashTaxReserve': 'Consumption tax reserve (estimate)',
  'acc102.cashKnown': 'Known cash balance',
  'acc102.cashBaseline': 'Baseline month-end balance',
  'acc102.cashRange': 'Projection period',
  'acc102.cashOpening': 'Opening cash balance',
  'acc102.cashMovement': 'Period net movement',
  'acc102.cashClosing': 'Closing cash balance',
  'acc102.cashProjectionNotice':
    'Gross cash starts at JPY 34,000,000 at September 2026 month-end. Receipts follow invoice due dates, or billing month plus two months if absent. Future receipts remain receivables. Reserve tax by billing month even before collection. Exclusive cash equals gross cash less accrued tax reserves since January 2026. No input credits, taxes-paid adjustments or tax splitting of manual entries. Management estimates, not tax liabilities or actual receipts. No backward projection.',
  'acc102.cashBeforeBaseline':
    'This period precedes the known baseline; cash balances are not projected backward.',
  'acc102.cashOutOfRange': 'This period exceeds the cash projection range. Select a nearer period.',
  'acc102.cashIncomplete':
    'Some monthly costs require review; subsequent cash balances remain unknown',
  'acc102.fixedExpenses': 'Fixed expenses',
  'acc102.fixedExpensesNotice':
    'Includes configured costs in every month of 2026, not actual payment records. They do not carry over to other years. Avoid duplicate manual entries.',
  'acc102.fixedExpenseAmount': 'Fixed monthly amount',
  'acc102.fixed.UR': 'UR',
  'acc102.fixed.UTILITIES': 'Utilities and waste collection',
  'acc102.fixed.REPAYMENT_1': 'Repayment 1',
  'acc102.fixed.WITHHOLDING_TAX': 'Individual withholding income tax',
  'acc102.fixed.LOCAL_TAX': 'Local tax',
  'acc102.fixed.OFFICE': 'Office',
  'acc102.fixed.AWS': 'AWS',
  'acc102.fixed.TEAMS': 'Teams',
  'acc102.fixed.CODEX': 'Codex',
  'acc102.fixedFxNotice':
    'Budget conversion: {currency} {amount} × {rate} JPY/{currency}; reference date: {date}. Rounded to whole yen, not an actual debit. No extra tax or fees; historical rates are not refreshed automatically.',
  'acc102.estimated': '(Estimated)',
  'acc102.referenceMonth': 'Reference month',
  'acc102.invoiceAuto': 'Invoice income (tax excluded)',
  'acc102.invoiceAutoNotice':
    'Uses Sales invoice list totals excluding tax by billing month, including unissued forecasts. Original invoices and receipts are unchanged. Receipts are not counted again. Avoid duplicate manual entries.',
  'acc102.commuteAuto': 'Commuting expenses',
  'acc102.commuteAutoNotice':
    'Includes all application statuses by source month. Only a completely empty month uses the latest earlier, completed month with applications, marked as estimated with its reference month. Existing applications are not topped up. Avoid duplicate manual entries.',
  'acc102.companyId': 'Company ID',
  'acc102.applications': 'Applications',
  'acc102.invoiceForecastAmount': 'Tax-exclusive forecast',
  'acc102.commuteAmount': 'Applied amount',
  'acc102.manualStatus': 'Manual entry status',
  'acc102.salaryPeriodTotal': 'Recorded payments in the query period',
  'menu.accounting.income-expense': 'Income / Expense',
  'acc102.pageTitle': 'Income / Expense',
  'acc102.INCOME': 'Income',
  'acc102.EXPENSE': 'Expense',
  'acc102.MANUAL': 'Manual',
  'acc102.INVOICE': 'Invoice',
  'acc102.SALARY': 'Payroll',
  'acc102.DRAFT': 'Incomplete',
  'acc102.CONFIRMED': 'Recorded',
  'acc102.VOID': 'Void',
  'acc102.add': 'Add manual entry',
  'acc102.edit': 'Edit',
  'acc102.save': 'Save',
  'acc102.cancel': 'Cancel',
  'acc102.confirm': 'Confirm',
  'acc102.void': 'Void',
  'acc102.confirmPrompt': 'Confirm this actual cash entry?',
  'acc102.voidPrompt': 'Void this entry and exclude it from totals?',
  'acc102.completeFirst': 'Save the actual date and amount first.',
  'acc102.confirmedEdit': 'Editing a confirmed entry immediately updates actual cash totals.',
  'acc102.direction': 'Direction',
  'acc102.title': 'Title',
  'acc102.targetMonth': 'Display month',
  'acc102.sourceMonth': 'Payroll source month',
  'acc102.cashDate': 'Actual date',
  'acc102.amount': 'Actual amount',
  'acc102.remarks': 'Remarks',
  'acc102.status': 'Status',
  'acc102.actions': 'Actions',
  'acc102.baseSalary': 'Base salary (reference)',
  'acc102.allowance': 'Allowance (reference)',
  'acc102.missingReference':
    'Payroll details require review. Reference amounts are never copied into actual amounts.',
  'acc102.required': 'This field is required.',
  'acc102.invalid':
    'Check the input. Amounts must be integers from 1 to 9,999,999,999,999; dates cannot be after today in Japan.',
  'acc102.empty': 'No matching entries.',
  'acc102.emptyINCOME': 'No income entries match the current filters',
  'acc102.emptyINCOMEHint':
    'Invoice list totals excluding tax, including unissued forecasts, are included automatically by billing month. Other income can be entered manually.',
  'acc102.emptyEXPENSE': 'No expense entries match the current filters',
  'acc102.emptyEXPENSEHint':
    'Payroll company costs and all commuting applications are included automatically by source month. Other expenses can be entered manually.',
  'acc102.sourceNotice':
    'Existing invoices and payroll references are not included automatically. Enter the actual date and amount and save to include the entry in totals, without a separate confirmation step.',
  'acc102.saveNotice':
    'Saving immediately updates actual cash totals and invoice payment status. Verify the actual date and amount first.',
  'acc102.saved': 'Operation completed.',
  'acc102.receipts': 'Receipts',
  'acc102.addReceipt': 'Add receipt',
  'acc102.invoice': 'Invoice number',
  'acc102.company': 'Company',
  'acc102.invoiceAmount': 'Invoice total (tax incl.)',
  'acc102.received': 'Recorded receipts',
  'acc102.remaining': 'Remaining balance',
  'acc102.billingMonth': 'Billing month',
  'acc102.reload': 'Reload',
  'acc102.invoiceSources': 'Invoice sources',
  'acc102.history': 'Include historical paid invoices',
  'acc102.legacyNotice':
    'The legacy payment status is preserved until the first actual receipt is saved. New receipts then take over permanently, even if later voided.',
  'acc102.salaryImport': 'Import payroll',
  'acc102.import': 'Import',
  'acc102.batchDate': 'Set payment dates',
  'acc102.salaryNotice':
    'Import payroll references only. Actual dates and amounts start blank and do not count toward totals. Complete each payment and save to record it. Reimporting preserves existing values.',
  'acc102.batchNotice':
    'Only dates on incomplete entries in the current results are updated; nothing is posted. Complete each amount and save individually. Recorded/void entries and actual amounts remain unchanged.',
  'acc102.cashNotice':
    'Complete the actual date and amount and save to include entries in totals. Incomplete entries are excluded. This is not a forecast or a formal financial statement.',
  'acc102.month': 'Month',
  'acc102.year': 'Year',
  'acc102.allStatuses': 'All statuses',
  'acc102.selectedTotal': 'Selected month income / expense',
  'acc102.annualTotal': 'Annual income / expense',
  'acc102.balance': 'Balance',
  'acc102.pending': 'Requires review',
  'acc102.companyCost': 'Total company cost',
  'acc102.companyCostNotice':
    'Payroll uses total company cost including estimated employer insurance and the zero-revenue JPY 100,000 rule. Invoices and commuting use their source month; only manual entries use cash dates. Do not register included costs twice.',
  'acc102.automaticCost': 'Included automatically',
  'acc102.costReview': 'Cost requires review',
  'acc102.costBasis': 'Calculation basis',
  'acc102.fixedCost': 'Zero revenue: fixed JPY 100,000',
  'acc102.standardCost': 'Standard cost',
  'acc102.accountId': 'Employee ID',
  'acc102.employee': 'Employee',
  'acc102.employees': 'employees',
  'acc102.monthDetails': '12-month breakdown',
  'acc102.unpaid': 'Unpaid',
  'acc102.partial': 'Partially paid',
  'acc102.paid': 'Paid',
  'acc102.error.ACC102_INVALID': 'Invalid input. Check amounts, dates and target month.',
  'acc102.error.ACC102_NOT_FOUND': 'Entry not found. Keep your input and reload the latest data.',
  'acc102.error.ACC102_CONFLICT':
    'The entry or request conflicts with another update. Keep your input and reload the latest entry.',
  'acc102.error.ACC102_OVERPAYMENT':
    'Confirmed receipts would exceed the invoice total. Check the remaining balance.',
  'acc102.error.ACC102_SOURCE_CHANGED':
    'The source has changed. Keep your input and review the latest source.',
  'acc102.error.ACC102_LEGACY_DISABLED':
    'Legacy payment updates are disabled. Reload and use Receipts.',
  'acc102.error.forbidden': 'You do not have permission for this operation.',
  'acc102.error.unauthorized': 'Your session has expired. Please sign in again.',
  'acc102.error.failed':
    'Loading or processing failed. Your input is preserved. Check the connection and retry.',
};
